// Nome distinto de propósito: este enum é sobre qual adquirente processa o PAGAMENTO.
// Não confundir com `AcquirerType` em Infrastructure/repositories/auth/IAuthService.ts,
// que é sobre autenticação de device (domínio diferente, mesmo nome coincidente antes deste rename).
export enum PaymentAcquirerType {
  Fiserv = 997,
  Adyen = 29,
}
